import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import NavBar from './components/NavBar';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import StatisticsDashboard from './pages/StatisticsDashboard';
import { AuthProvider } from './contexts/AuthContext';
import { AnnouncementProvider } from './contexts/AnnouncementContext';
import { SlideshowProvider } from './contexts/SlideshowContext';
import { OrgChartProvider } from './contexts/OrgChartContext';
import AdminRoute from './components/AdminRoute';
import FirebaseConnectionStatus from './components/FirebaseConnectionStatus';
import { useAuth } from './contexts/AuthContext';
import EmailTest from './components/EmailTest';
import ServerTest from './components/ServerTest';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// A component to conditionally render the NavBar
const NavBarWrapper = ({ children }) => {
  const { currentUser, isAdmin } = useAuth();
  const isAdminRoute = window.location.pathname.includes('/admin') || 
                        window.location.pathname.includes('/statistics');
  
  return (
    <>
      {!isAdminRoute && <NavBar />}
      {children}
    </>
  );
};

function App() {
  // Log when the app initializes
  useEffect(() => {
    console.log('App initialized');
  }, []);

  return (
    <AuthProvider>
      <AnnouncementProvider>
        <SlideshowProvider>
          <OrgChartProvider>
            <Router>
              <div className="app">
                <FirebaseConnectionStatus />
                <ToastContainer position="top-right" autoClose={5000} />
                <Routes>
                  <Route path="/" element={
                    <NavBarWrapper>
                      <Home />
                    </NavBarWrapper>
                  } />
                  <Route path="/register" element={
                    <NavBarWrapper>
                      <Register />
                    </NavBarWrapper>
                  } />
                  <Route path="/login" element={
                    <NavBarWrapper>
                      <Login />
                    </NavBarWrapper>
                  } />
                  <Route 
                    path="/admin" 
                    element={<AdminDashboard />}
                  />
                  <Route 
                    path="/statistics" 
                    element={<StatisticsDashboard />}
                  />
                  <Route path="/email-test" element={<EmailTest />} />
                  <Route path="/server-test" element={<ServerTest />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </div>
            </Router>
          </OrgChartProvider>
        </SlideshowProvider>
      </AnnouncementProvider>
    </AuthProvider>
  );
}

export default App; 